module.exports = __webpack_public_path__ + "img/section_1_stamp.2944ef37.png";